"use client";
import Image from "next/image";
import MoreFeatures from "@/assets/images/videos/video-hero.svg";
import VideoTabs from "./VideoTabs";
import CommonSubtitle from "../common/CommonSubtitle";
import CommonTitle from "../common/CommonTitle";
import bgHeroImage from "@/assets/images/hero-bg-home.svg";
import { FaLock, FaShieldAlt } from "react-icons/fa";
import { FaBolt } from "react-icons/fa";

const heroFeatures = [
  {
    title: "60+ videos",
    icon: <FaBolt size={20} className="text-[#202020]" />,
  },
  {
    title: "Step-by-step guides",
    icon: <FaShieldAlt size={20} className="text-[#202020]" />,
  },
  {
    title: "Deeper insights",
    icon: <FaLock size={20} className="text-[#202020]" />,
  },
];

const VideoSection = () => {
  return (
    <>
      <section
        className="relative z-10 overflow-hidden"
        style={{
          background: `url(${bgHeroImage.src})`,
          backgroundColor: "#ffffff",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "bottom",
        }}
      >
          <div className="container relative mx-auto px-4 pb-8 pt-[100px] xl:pb-16 xl:pt-[120px]">
            <div className="flex flex-col items-center justify-center lg:flex-row">
              <div className="flex flex-col">
                <div className="mb-6 inline-flex w-fit rounded-full bg-white px-3 py-1 text-sm font-semibold">
                  <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                    Video Library
                  </span>
                </div>

                <CommonTitle
                  as="h1"
                  color="#202020"
                  fontSizeClass="text-[36px] lg:text-[48px]"
                  fontWeightClass="font-bold"
                >
                  Master Kroolo with <br className="hidden lg:block" />{" "}
                  <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                    step-by-step videos
                  </span>
                </CommonTitle>
                <CommonSubtitle fontSizeWeight="max-w-[560px] mt-6">
                  From onboarding to power features - explore our video guides and
                  learn how to get the most out of Kroolo.
                </CommonSubtitle>
                <div className="mt-4 flex flex-wrap items-center gap-6">
                  {heroFeatures.map((feature, index) => {
                    return (
                      <div
                        key={index}
                        className="flex items-center gap-2 text-[#202020]"
                      >
                        {feature.icon}
                        <span className="text-[16px]">{feature.title}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="relative aspect-video overflow-hidden rounded-2xl">
                <Image
                  src={MoreFeatures}
                  alt="Kroolo video tutorials and demos"
                  className="h-full w-full object-contain"
                  priority
                />
              </div>
            </div>
          </div>
          </section>
        <div className="container mx-auto px-4 pb-4 pt-4 xlg:pb-12 xlg:pt-16">
          <div className="mx-auto mb-8 max-w-[850px] space-y-2 text-center xl:mb-8">
            <h2 className="mb-4 text-[24px] font-bold text-[#202020] lg:text-[32px]">
              Your learning Journey starts Here:{" "}
              <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent">
                Watch Now.
              </span>
            </h2>
            <CommonSubtitle>
              Begin your learning journey with our comprehensive video
              tutorials. These step-by-step guides make mastering Kroolo simple
              and effective. Gain the deeper insights of the product.
            </CommonSubtitle>
          </div>
          <VideoTabs />
        </div>
      
    </>
  );
};

export default VideoSection;
